require("core-js/modules/esnext.global-this.js");

!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r(require("react"), require("prop-types"), require("@leafygreen-ui/emotion")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "@leafygreen-ui/emotion"], r) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).CaretDown = e.CaretDown || {}, e.CaretDown.js = r(e.React, e.PropTypes, e["@leafygreen-ui/emotion"]));
}(this, function (e, r, t) {
  "use strict";

  function a(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  function n(e) {
    if (e && e.__esModule) return e;
    var r = Object.create(null);
    return e && Object.keys(e).forEach(function (t) {
      if ("default" !== t) {
        var a = Object.getOwnPropertyDescriptor(e, t);
        Object.defineProperty(r, t, a.get ? a : {
          enumerable: !0,
          get: function get() {
            return e[t];
          }
        });
      }
    }), r.default = e, Object.freeze(r);
  }

  var l = n(e),
      i = a(r);

  function o(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }

  function u() {
    return u = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];

        for (var a in t) {
          Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
        }
      }

      return e;
    }, u.apply(this, arguments);
  }

  function f(e, r) {
    if (null == e) return {};

    var t,
        a,
        n = function (e, r) {
      if (null == e) return {};
      var t,
          a,
          n = {},
          l = Object.keys(e);

      for (a = 0; a < l.length; a++) {
        t = l[a], r.indexOf(t) >= 0 || (n[t] = e[t]);
      }

      return n;
    }(e, r);

    if (Object.getOwnPropertySymbols) {
      var l = Object.getOwnPropertySymbols(e);

      for (a = 0; a < l.length; a++) {
        t = l[a], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
      }
    }

    return n;
  }

  function c(e, r) {
    return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(r)
      }
    }));
  }

  var s,
      b,
      p = {
    small: 14,
    default: 16,
    large: 20,
    xlarge: 24
  };

  var d = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"],
      y = function y(e) {
    var r,
        a = e.className,
        n = e.size,
        i = void 0 === n ? 16 : n,
        y = e.title,
        g = e["aria-label"],
        m = e["aria-labelledby"],
        O = e.fill,
        v = e.role,
        j = void 0 === v ? "img" : v,
        h = f(e, d),
        w = t.css(s || (s = c(["\n    color: ", ";\n  "])), O),
        C = t.css(b || (b = c(["\n    flex-shrink: 0;\n  "]))),
        x = function (e, r, t) {
      var a,
          n,
          l = t["aria-label"],
          i = t["aria-labelledby"],
          u = t.title;

      switch (e) {
        case "img":
          return l || i || u ? (o(a = {}, "aria-labelledby", i), o(a, "aria-label", l), o(a, "title", u), a) : {
            "aria-label": (n = r, "".concat(n.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon"))
          };

        case "presentation":
          return {
            "aria-hidden": !0,
            alt: ""
          };
      }
    }(j, "CaretDown", (o(r = {
      title: y
    }, "aria-label", g), o(r, "aria-labelledby", m), r));

    return l.createElement("svg", u({
      className: t.cx(o({}, w, null != O), C, a),
      height: "number" == typeof i ? i : p[i],
      width: "number" == typeof i ? i : p[i],
      role: j
    }, x, h, {
      viewBox: "0 0 16 16"
    }), l.createElement("path", {
      d: "M8.67903 10.7962C8.45271 11.0679 8.04729 11.0679 7.82097 10.7962L4.63962 6.97649C4.3213 6.59428 4.5824 6 5.06866 6L11.4313 6C11.9176 6 12.1787 6.59428 11.8604 6.97649L8.67903 10.7962Z",
      fill: "currentColor"
    }));
  };

  return y.displayName = "CaretDown", y.isGlyph = !0, y.propTypes = {
    fill: i.default.string,
    size: i.default.oneOfType([i.default.number, i.default.string]),
    className: i.default.string
  }, y;
});